import CompanyRoutes from './CompanyRoutes'
import CustomerRoutes from './CustomerRoutes'
import DefaultRoutes from './DefaultRoutes'
import OrderServiceRoutes from './OrderServiceRoutes'
import BudgetRoutes from './BudgetRoutes'
import InvoiceRoutes from './InvoiceRoutes'
import UserRoutes from './UserRoutes'

export default [
  ...DefaultRoutes,
  ...CompanyRoutes,
  ...CustomerRoutes,
  ...OrderServiceRoutes,
  ...BudgetRoutes,
  ...InvoiceRoutes,
  ...UserRoutes
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/IndexRoutes.js